import BodyModalWithActions from '../../../../components/common/modals/bodyModalWithActions'
import { Typography, SxProps, Theme } from '@mui/material'
import ContainedButton from '../../../../components/common/buttons/containedButton'

interface Props {
  handleClose: () => void
  sx?: SxProps<Theme> 
}

const BodyModalSuccess = ({ handleClose, sx }: Props) => {
  return (
    <BodyModalWithActions
      title='Changement de date effectué'
      type='confirm'
      content={
        <Typography variant='body1'>
          Vous allez recevoir une confirmation de changement par courriel et la section Formations de votre espace membre va être mise à jour
        </Typography>
      }
      sx={{...sx}}
      actions={
        <>
          <ContainedButton
            variant='principal'
            title='OK'
            handleClick={handleClose}
          />
        </>
      }
    />
  )
}

export default BodyModalSuccess
